import AvatarPosition from './ui/avatar-position';
import AvatarSettings from './ui/avatar-settings';

export const Studio = {
  AvatarPosition,
  AvatarSettings,
};
